/* Kuba PDP · kuba-sticky.js
   1) Barra fixa de compra ([data-kb-sticky]): aparece depois de `data-after` telas de rolagem,
      some enquanto a caixa de compra (`data-watch`, ex. "#produto") está visível.
      Botão: se o produto não tem escolha de variante (ex. Mali 2), compra direto
      (clica no botão principal da caixa de compra); se tem variantes, rola suave até a caixa.
   2) CTA final (.kb-cta__btn apontando pra #produto): mesma regra do botão da barra fixa.
   3) Botão "+" dos cards de peça ([data-kb-add]): adiciona a variante ao carrinho via /cart/add.js
      e dispara cart:refresh / cart:updated.
   Idempotente: o editor de tema re-renderiza seções → init() roda de novo em shopify:section:load. */
(function () {
  if (window.__kbStickyLoaded) { if (window.__kbStickyInit) window.__kbStickyInit(); return; }
  window.__kbStickyLoaded = true;

  /* ---------- compra direta a partir de botões fora da caixa ---------- */
  /* Devolve o botão principal da caixa de compra quando dá pra comprar sem o cliente escolher nada:
     produto sem seletor de variante (ou com uma só) e botão disponível. Senão, null → rola até a caixa. */
  function directBuyButton(hasVariantPicker) {
    var pdp = document.querySelector('[data-kb-pdp]');
    if (!pdp) return null;
    // várias versões: só compra direto se o botão tem seletor de versão ao lado (barra fixa do Uni); senão rola até a caixa
    if (!hasVariantPicker && pdp.querySelectorAll('[data-kb-variant]').length > 1) return null;
    var buy = pdp.querySelector('form.kb-form [data-kb-buy]');
    if (!buy || buy.disabled || buy.hidden) return null;
    return buy;
  }

  function buyOrScroll(e, el, fallback) {
    var bar = el.closest && el.closest('[data-kb-sticky]');
    var buy = directBuyButton(!!(bar && bar.querySelector('[data-kb-sticky-variant]')));
    if (buy) {
      e.preventDefault();
      if (el.classList.contains('is-busy')) return;
      el.classList.add('is-busy');
      // quantidade escolhida na barra fixa (se houver) vai pro formulário principal só durante esta compra
      var qEl = bar && bar.querySelector('[data-kb-sticky-qty]');
      var qty = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;
      var mainQty = buy.form ? buy.form.querySelector('input[name="quantity"]') : null;
      if (mainQty && qty !== 1) {
        var prevQty = mainQty.value;
        mainQty.value = qty;
        setTimeout(function () { mainQty.value = prevQty; }, 1500);
      }
      buy.click();
      setTimeout(function () { el.classList.remove('is-busy'); }, 4000);
      return;
    }
    var id = (el.getAttribute('href') || '').replace(/^.*#/, '');
    var t = id && document.getElementById(id);
    if (!t) t = fallback;
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }

  /* ---------- barra fixa ---------- */
  function sticky() {
    document.querySelectorAll('[data-kb-sticky]').forEach(function (bar) {
      if (bar.__kb) return;
      bar.__kb = true;
      bar.hidden = false;

      // no celular o tema tem uma barra de navegação fixa no rodapé (.hdt-toolbar: Earphones / Headphones):
      // a barra de compra fica logo acima dela, sem cobri-la (--kb-sticky-lift = altura da navegação)
      var toolbar = document.querySelector('.hdt-toolbar');
      var lift = function () {
        var h = 0;
        if (toolbar) {
          var cs = getComputedStyle(toolbar), r = toolbar.getBoundingClientRect();
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.bottom >= window.innerHeight - 2) h = r.height;
        }
        bar.style.bottom = h ? h + 'px' : '';
        bar.style.setProperty('--kb-sticky-lift', h + 'px');
      };
      lift();
      window.addEventListener('resize', lift);
      window.addEventListener('load', lift);
      var after = parseFloat(bar.dataset.after);
      if (isNaN(after)) after = 1;
      var watchSel = bar.dataset.watch || '#produto';
      var target = null;
      try { target = document.querySelector(watchSel); } catch (e) { target = null; }
      if (!target) target = document.querySelector('[data-kb-pdp]');
      var boxVisible = false;

      // data-show="buy": aparece assim que o botão principal de compra sai por cima da tela (como no tema original)
      var mainBuy = bar.dataset.show === 'buy' ? document.querySelector('[data-kb-pdp] form.kb-form [data-kb-buy]') : null;
      var buyPassed = false;

      var paint = function () {
        if (mainBuy) { bar.classList.toggle('is-on', buyPassed); return; }
        var scrolled = (window.scrollY || window.pageYOffset || 0) > window.innerHeight * after;
        bar.classList.toggle('is-on', scrolled && !boxVisible);
      };

      if (mainBuy && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { buyPassed = !en.isIntersecting && en.boundingClientRect.bottom < 0; });
          paint();
        }).observe(mainBuy);
      } else if (mainBuy) {
        window.addEventListener('scroll', function () { buyPassed = mainBuy.getBoundingClientRect().bottom < 0; }, { passive: true });
      }

      // seletor de quantidade
      var qIn = bar.querySelector('[data-kb-sticky-qty]');
      if (qIn) {
        var setQ = function (n) { qIn.value = Math.max(1, Math.min(99, n || 1)); };
        var minus = bar.querySelector('[data-kb-sticky-minus]'), plus = bar.querySelector('[data-kb-sticky-plus]');
        if (minus) minus.addEventListener('click', function () { setQ((parseInt(qIn.value, 10) || 1) - 1); });
        if (plus) plus.addEventListener('click', function () { setQ((parseInt(qIn.value, 10) || 1) + 1); });
        qIn.addEventListener('change', function () { setQ(parseInt(qIn.value, 10)); });
      }

      if (!mainBuy && target && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { boxVisible = en.isIntersecting; });
          paint();
        }, { threshold: 0.05 });
        io.observe(target);
      } else if (!mainBuy && target) {
        var check = function () {
          var r = target.getBoundingClientRect();
          boxVisible = r.bottom > 0 && r.top < window.innerHeight;
        };
        window.addEventListener('scroll', check, { passive: true });
        check();
      }

      window.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint);
      paint();

      // seletor de versão: espelha as versões da caixa de compra nos dois sentidos
      var vSels = bar.querySelectorAll('[data-kb-sticky-variant]');
      if (vSels.length) {
        var radios = document.querySelectorAll('[data-kb-pdp] [data-kb-variant]');
        var showVariant = function (id) {
          vSels.forEach(function (s) {
            s.value = id;
            var o = s.options[s.selectedIndex];
            var lab = s.parentNode.querySelector('[data-kb-sticky-var-label]');
            if (lab && o) lab.textContent = o.dataset.title || o.textContent;
          });
          var o0 = vSels[0].options[vSels[0].selectedIndex];
          if (o0) bar.querySelectorAll('[data-kb-sticky-price]').forEach(function (p) { p.textContent = o0.dataset.price || ''; });
        };
        vSels.forEach(function (s) {
          s.addEventListener('change', function () {
            showVariant(s.value);
            radios.forEach(function (r) {
              if (r.value === s.value && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
            });
          });
        });
        radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) showVariant(r.value); }); });
        radios.forEach(function (r) { if (r.checked) showVariant(r.value); });
      }

      var go = bar.querySelector('[data-kb-sticky-go]');
      if (go) {
        go.addEventListener('click', function (e) { buyOrScroll(e, go, target); });
      }
    });
  }

  /* ---------- CTA final ---------- */
  function ctas() {
    document.querySelectorAll('a.kb-cta__btn[href^="#"]').forEach(function (a) {
      if (a.__kb) return;
      a.__kb = true;
      a.addEventListener('click', function (e) {
        var box = document.querySelector('[data-kb-pdp]');
        // Mali fica de fora enquanto o Teste 23.0 (PP) do Intelligems roda; quando terminar, apagar este if.
        if (/\/products\/mali-2\/?$/.test(location.pathname)) { buyOrScroll(e, a, box); return; }
        // Sempre rola até a caixa de compra: o cliente vê preço, versão e frete antes de adicionar.
        var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
        var t = (id && document.getElementById(id)) || box;
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  /* ---------- botão "+" das peças ---------- */
  function notifyCart() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    } catch (e) {}
  }

  function addButtons() {
    document.querySelectorAll('[data-kb-add]').forEach(function (btn) {
      if (btn.__kb) return;
      btn.__kb = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vid = Number(btn.getAttribute('data-kb-add'));
        if (!vid || btn.classList.contains('is-busy')) return;
        var label = btn.textContent;
        btn.classList.add('is-busy');
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            btn.classList.remove('is-busy');
            if (!res.ok) {
              btn.textContent = '!';
              btn.title = (res.body && res.body.description) || 'Não foi possível adicionar agora.';
              setTimeout(function () { btn.textContent = label; btn.title = ''; }, 2400);
              return;
            }
            btn.classList.add('is-done');
            btn.textContent = '✓';
            notifyCart();
            setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 1800);
          })
          .catch(function () {
            btn.classList.remove('is-busy');
            btn.textContent = '!';
            setTimeout(function () { btn.textContent = label; }, 2400);
          });
      });
    });
  }

  function init() { sticky(); ctas(); addButtons(); }
  window.__kbStickyInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
